module.exports = __webpack_public_path__ + "img/1325.5a136012.gif";